import React from 'react';
import { getErrorText } from '../../../services/errors/getErrorText';
import { Alert } from '../Alert/Alert';
import { localise } from '../../../services/lang/lang';
export const ErrorAwareAlertBox = ({ noun, error, ...rest }) => {
    const message = getErrorText(error, noun);
    return (React.createElement(Alert, { ...rest, status: "error", title: localise('SOMETHING_WRONG'), icon: true, "data-testid": "error-aware-alert-box" }, message));
};
